import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  MessageCampaign,
  MessageLog,
  SendCampaignRequest,
  SendCampaignResult,
  SendMessageResult,
  SendSingleMessageRequest,
} from "../models/MessageModels";

const API_BASE_URL = Constants.API_BASE_URL;

export async function sendMessageAsync(
  token: string,
  request: SendSingleMessageRequest,
): Promise<ResponseMessage<SendMessageResult>> {
  const response = await axios.post(`${API_BASE_URL}/messages/send`, request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function createCampaignAsync(
  token: string,
  request: SendCampaignRequest,
): Promise<ResponseMessage<SendCampaignResult>> {
  const response = await axios.post(
    `${API_BASE_URL}/messages/campaigns`,
    request,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getCampaignsByOrganizationAsync(
  token: string,
  organizationId: string,
): Promise<ResponseMessage<MessageCampaign[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/messages/campaigns/organization/${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getCampaignByIdAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<MessageCampaign | null>> {
  const response = await axios.get(`${API_BASE_URL}/messages/campaigns/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function getMessageLogsByOrganizationAsync(
  token: string,
  organizationId: string,
  messageType?: number,
): Promise<ResponseMessage<MessageLog[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/messages/logs/organization/${organizationId}`,
    {
      params: {
        messageType,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getMessageLogsByClientAsync(
  token: string,
  clientId: string,
): Promise<ResponseMessage<MessageLog[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/messages/logs/client/${clientId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}